import React from 'react';
import Select from 'react-select';

const OfferingModal = ({ isOpen, setIsOpen, statusOptions, formData, setFormData, handleSubmit }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            status: selectedOption.value
        }));
    };

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="oms-modal-title">Service/Offering Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="service" className="oms-form-label">Service/Offering</label>
                        <input
                            type="text"
                            id="service"
                            name="offered"
                            value={formData.offered}
                            onChange={handleChange}
                            placeholder="Enter service/offering"
                            required
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">Status</label>
                        <Select
                            options={statusOptions}
                            placeholder="Select status"
                            onChange={handleStatusChange}
                            value={statusOptions.find(opt => opt.value === formData.status)}
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};



export default OfferingModal;
